import clsx from 'clsx';
import { useMemo } from 'react';
import { EventItemHeader } from 'src/components/Events/EventItemHeader';
import { Checkbox } from 'src/core/interim/Checkbox';
import { vars } from 'src/core/themes';
import { ChevronRightIcon } from 'src/svgs/Viagogo';
import { getPerformerAndVenueForEvent } from 'src/utils/eventWithDataUtils';
import { CatalogResults, Event, Performer, Venue } from 'src/WebApiController';

import * as styles from './EventSearch.css';
import {
  EventSearchItemDiv,
  EventSearchItemInfoContainer,
} from './EventSearch.styled';

export const EventSearchItem = ({
  event,
  performer,
  venue,
  isSelected,
  catalog,
  onChecked,
  isSingleSelect,
  isDisabled,
  displayOnly,
}: {
  event: Event;
  performer?: Performer | null;
  venue?: Venue | null;
  isSelected?: boolean;
  catalog?: CatalogResults;
  onChecked: (
    event: Event,
    isSelected: boolean,
    performer?: Performer | null,
    venue?: Venue | null
  ) => void;
  isSingleSelect?: boolean;
  isDisabled?: boolean;
  displayOnly?: boolean;
}) => {
  const { performer: performerFromCatalog, venue: venueFromCatalog } =
    getPerformerAndVenueForEvent(event, catalog);

  const [sanitizedPerformer, sanitizedVenue] = useMemo(() => {
    return [performer ?? performerFromCatalog, venue ?? venueFromCatalog];
  }, [performer, performerFromCatalog, venue, venueFromCatalog]);
  return (
    <div
      data-testid="event-search-item"
      className={styles.eventSearchItemContainer}
      style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
      onClick={(e) => {
        e.stopPropagation();
        if (!isDisabled) {
          onChecked?.(event, !isSelected, sanitizedPerformer, sanitizedVenue);
        }
      }}
    >
      <EventSearchItemDiv
        className={clsx(styles.eventSearchItemDiv, {
          [styles.eventSearchItemDivSelected]: isSelected,
        })}
      >
        {!displayOnly && !isSingleSelect && (
          <Checkbox
            checked={Boolean(isSelected)}
            disabled={isDisabled}
            // This is not really needed since we are using the onClick event but it is retained to be consistent with the other checkbox
            onChange={() => {
              if (!isDisabled) {
                onChecked?.(
                  event,
                  !isSelected,
                  sanitizedPerformer,
                  sanitizedVenue
                );
              }
            }}
          />
        )}

        <EventSearchItemInfoContainer>
          <EventItemHeader
            event={event}
            performer={sanitizedPerformer}
            venue={sanitizedVenue}
            showMappingState
          />
        </EventSearchItemInfoContainer>
        {!displayOnly && isSingleSelect && (
          <div className={styles.chevronIconContainer}>
            <ChevronRightIcon fill={vars.color.textPrimary} />
          </div>
        )}
      </EventSearchItemDiv>
    </div>
  );
};
